let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ecT6J")).then(() => parcelRequire('2lvJW'));